var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('worker',{attrs:{"title":"非在职员工信息管理","fun-auth-other":_vm.funAuth,"job-type-c":['辞职辞退', '开除', '退休']}})}
var staticRenderFns = []

export { render, staticRenderFns }